
export const FormattedValue = (numberValue : number) => {
    let formattedValue = '';
    const decimalCount = numberValue.toString().split('.')[1]?.length || 0;
    if (decimalCount <= 2) {
        formattedValue = numberValue.toFixed(2);
    } else{
    // More than 2 decimals
        formattedValue = (Math.trunc(numberValue * 100) / 100).toFixed(2);
    }
    return formattedValue;
}
